import React, { useEffect, useState } from "react";
import { Form, Select, Button, message, Tooltip } from "antd";
import { fetchTest } from "../test/FetchTest";
import { fetchPackage } from "../package/FetchPackage";
import { useSelector } from "react-redux";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { createOrderItem } from "../../endpoints/API";

const { Option } = Select;

const OrderItems = ({
  customerData,
  setIsModalVisible,

  fetchCustomerData,
}) => {
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const [isTestDisabled, setIsTestDisabled] = useState(false);
  const [isPackageDisabled, setIsPackageDisabled] = useState(false);
  const [test, setTest] = useState([]);
  const [packages, setPackages] = useState([]);
  const isUser = useSelector((state) => state.user.user);

  const handleOrderTypeChange = (value) => {
    if (value === "test") {
      setIsPackageDisabled(true);
      setIsTestDisabled(false);
      form.setFieldsValue({ package: undefined }); // Reset package select
    } else if (value === "package") {
      setIsTestDisabled(true);
      setIsPackageDisabled(false);
      form.setFieldsValue({ test: undefined }); // Reset test select
    }
  };

  const [form] = Form.useForm();

  const handleFinish = async (values) => {
    // Prepare the payload with form values
    const payload = {
      familymember: values.familyMember,
      //   orderType: values.orderType,
      test: values.test ? values.test : "",
      package: values.package ? values.package : "",
      created_by: isUser.user_id,
      status: "enable",
    };

    try {
      // Send POST request to "/create-order-item/"
      const response = await createOrderItem(payload);

      // Check if the response is successful
      if (!response.statusText=="OK") {
        // If not, throw an error
        throw new Error("Failed to create order item");
      }

      // Parse the response JSON (if needed)
      const data = response?.data;

      // Optionally, show a success message or perform other actions
      message.success("Order item created successfully!");
      form.resetFields();
      fetchCustomerData();
      setIsModalVisible(false);
    } catch (error) {
      message.error(error?.response?.data?.error||"Failed to create order item. Please try again.");
    }
  };

  useEffect(() => {
    const getTestAndPackage = async () => {
      try {
        await fetchTest(setTest, baseUrl, prodTestUrl);
        await fetchPackage(setPackages, baseUrl, prodTestUrl);
      } catch (error) {
        message.error(error?.response?.data?.error||"Failed to fetch data.");
      }
    };

    getTestAndPackage();
  }, []);

  const isFamilyMemberDisabled = customerData?.family_member?.length === 0;


  return (
    <div>
      <Form layout="vertical" form={form} onFinish={handleFinish}>
        {/* Family Member Select */}
        <Form.Item
          label="Family Member"
          name="familyMember"
          rules={[
            {
              required: !isFamilyMemberDisabled,
              message: "Please select a family member",
            },
          ]}
        >
          <Tooltip
            title={isFamilyMemberDisabled ? "Select customer first" : ""}
          >
            <Select
              placeholder="Select a family member"
              disabled={isFamilyMemberDisabled}
              onChange={(value) => form.setFieldsValue({ familyMember: value })}
            >
              {customerData?.family_member?.map((member) => (
                <Option key={member?.id} value={member?.id}>
                  {`${member?.first_name} ${member?.middle_name || ""} ${member?.last_name
                    }`.trim()}{" "}
                  <span>({member.family_member_type.name})</span>
                </Option>
              ))}
            </Select>
          </Tooltip>
        </Form.Item>

        {/* Order Type Select */}
        <Form.Item
          label="Order Type"
          name="orderType"
          rules={[{ required: true, message: "Please select an order type" }]}
        >
          <Select
            placeholder="Select order type"
            onChange={handleOrderTypeChange}
          >
            <Option value="test">Test</Option>
            <Option value="package">Package</Option>
          </Select>
        </Form.Item>

        {/* Test Select (Multiple) */}
        <Form.Item
          label="Test"
          name="test"
          rules={[
            {
              required: !isTestDisabled,
              message: "Please select at least one test",
            },
          ]}
        >
          <Select
            placeholder="Select tests"
            disabled={isTestDisabled}
            showSearch
            filterOption={(input, option) => {
              const label = option?.label;
              if (typeof label === "string") {
                return label.toLowerCase().includes(input.toLowerCase());
              }
              return false;
            }}
            options={test?.map((testItem) => ({
              label: `${testItem.name} (${testItem.mrp ? `₹${testItem.mrp}` : ""
                }) (${testItem.lab.name})`,
              value: testItem.id,
            }))}
          // Optionally: add `optionLabelProp="label"` if you want the selected text to show the full label
          />
        </Form.Item>

        {/* Package Select */}
        <Form.Item
          label="Package"
          name="package"
          rules={[
            {
              required: !isPackageDisabled,
              message: "Please select a package",
            },
          ]}
        >
          <Select
            placeholder="Select a package"
            disabled={isPackageDisabled}
            showSearch
            filterOption={(input, option) => {
              const label = option?.label;
              if (typeof label === "string") {
                return label.toLowerCase().includes(input.toLowerCase());
              }
              return false;
            }}
            options={packages?.packages?.map((packageItem) => ({
              label: `${packageItem.name_of_package} (${packageItem.mrp ? `₹${packageItem.mrp}` : ""
                }) (${packageItem.lab_name})`,
              value: packageItem.id,
            }))}
          />
        </Form.Item>

        {/* Submit Button */}
        <Form.Item style={{ display: "flex", justifyContent: "center" }}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
          <Button className="ml-[.5rem]">Cancel</Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default OrderItems;
